/** Station box widths inside `column_station_info` — header labels must match. */
export const STATION_ROUTE_STATION_BOX_LEFT_WIDTH_PX = 30;
export const STATION_ROUTE_STATION_BOX_RIGHT_WIDTH_PX = 81;

/** Desktop grid for station-route rows — equal station column width, station expands on resize. */
export const STATION_ROUTE_ROW_GRID_TEMPLATE =
  "minmax(0, 33px) minmax(0, 1fr) minmax(0, 130px) minmax(0, 55px) minmax(0, 56px)" as const;

export const STATION_ROUTE_ROW_GRID_GAP = "3px" as const;
